"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.3542 9.77083H9.64591C8.12813 9.77632 6.67409 10.3817 5.60085 11.4549C4.52761 12.5282 3.92224 13.9822 3.91675 15.5V34.5C3.92224 36.0178 4.52761 37.4718 5.60085 38.5451C6.67409 39.6183 8.12813 40.2237 9.64591 40.2292H40.3542C41.872 40.2237 43.3261 39.6183 44.3993 38.5451C45.4725 37.4718 46.0779 36.0178 46.0834 34.5V15.5C46.0779 13.9822 45.4725 12.5282 44.3993 11.4549C43.3261 10.3817 41.872 9.77632 40.3542 9.77083ZM40.3542 12.8958L26.9376 23.8542C26.389 24.2973 25.7052 24.5389 25.0001 24.5389C24.2949 24.5389 23.6111 24.2973 23.0626 23.8542L9.64591 12.9167H40.3542V12.8958ZM42.9584 34.5C42.9584 35.1907 42.684 35.853 42.1957 36.3414C41.7073 36.8298 41.0449 37.1042 40.3542 37.1042H9.64591C8.95525 37.1042 8.29287 36.8298 7.80449 36.3414C7.31611 35.853 7.04175 35.1907 7.04175 34.5V15.5C7.06337 15.3018 7.10525 15.1063 7.16675 14.9167L19.3334 24.8542L13.8959 30.2917C13.6033 30.5846 13.439 30.9818 13.439 31.3958C13.439 31.8099 13.6033 32.207 13.8959 32.5C14.1889 32.7926 14.586 32.957 15.0001 32.957C15.4141 32.957 15.8113 32.7926 16.1042 32.5L21.8126 26.7917C22.7728 27.3769 23.8756 27.6864 25.0001 27.6864C26.1246 27.6864 27.2274 27.3769 28.1876 26.7917L33.8959 32.5C34.1889 32.7926 34.586 32.957 35.0001 32.957C35.4141 32.957 35.8113 32.7926 36.1042 32.5C36.3968 32.207 36.5612 31.8099 36.5612 31.3958C36.5612 30.9818 36.3968 30.5846 36.1042 30.2917L30.6667 24.8542L42.8334 14.9167C42.8949 15.1063 42.9368 15.3018 42.9584 15.5V34.5Z",
    fill: fill
  }));
};

exports["default"] = _default;